import { Suspense } from 'react';
import { CompanyMinifiedRowType } from '@api';
import { SearchTableInput, Tabs, useManageTableContext } from '@common';
import { AddCompany, CompaniesOverviewTable } from '@features';
import { Box, Group, Skeleton } from '@mantine/core';
import { PageLayout } from '@pages';
import { useTranslation } from 'react-i18next';

type CompaniesPagePropsType = {
  companies: CompanyMinifiedRowType[];
  isPending: boolean;
};

export const CompaniesPage: React.FC<CompaniesPagePropsType> = ({
  companies,
  isPending,
}) => {
  const { t } = useTranslation('companies');

  const {
    tableArguments: {
      search: { searchValue, setSearchValue },
    },
  } = useManageTableContext();

  const tabs = [
    {
      label: t('TABS.OVERVIEW'),
      value: 'overview',
    },
  ];

  return (
    <PageLayout title={t('TITLE')}>
      <Tabs value="overview">
        <Tabs.TabsList>
          {tabs.map((tab) => (
            <Tabs.Tab key={tab.value} value={tab.value} to="/companies">
              {tab.label}
            </Tabs.Tab>
          ))}
          <Tabs.TabsListActions>
            <Suspense fallback={<Skeleton height={30} width={45} />}>
              <AddCompany />
            </Suspense>
          </Tabs.TabsListActions>
        </Tabs.TabsList>
      </Tabs>
      <Box py="md">
        <Group justify="end" mb="xs">
          <SearchTableInput
            search={searchValue ?? ''}
            setSearchValue={setSearchValue}
            autoFocus
          />
        </Group>
        <CompaniesOverviewTable companies={companies} isPending={isPending} />
      </Box>
    </PageLayout>
  );
};
